import { render } from "./CustomNotification.vue?vue&type=template&id=33a4b1d1&scoped=true"
const script = {}

import "./CustomNotification.vue?vue&type=style&index=0&id=33a4b1d1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a4b1d1"]])

export default __exports__